import React, { useState } from 'react';
import { Input, Label, ValidationMessage } from '@gjensidige/builders-components';
import { useAppSelector } from '../../hooks/appHooks';
import { getProductName } from '../../store/slices/offerSlice';
import { ITextBoxProps } from '../../interfaces/EnquiryInterface';
import { Validator } from '../../utils/Validator';
import { EnquiryOptionImmutable } from './EnquiryOptionImmutable';
import { HelpText } from './HelpText';

interface InputStatusProps {
  isValid: boolean;
  errorMessage: string;
}
export const EnquiryOptionTextBox: React.FC<ITextBoxProps> = (
  props: ITextBoxProps
) => {
  const [errorMessage, setErrorMessage] = useState(props.errorMessage);
  const [isValid, setIsValid] = useState(true);
  const productName = useAppSelector(getProductName);
  const pricingQuestions = useAppSelector(
    (state) => state.insurance.pricingQuestions
  );

  const handleChange = (event: any) => {
    const customerInput = props.isNumeric
      ? filterNumericValue(event.currentTarget.value)
      : event.currentTarget.value;

    const inputStatus: InputStatusProps = Validator.validate(
      props.questionType,
      customerInput,
      productName,
      pricingQuestions
    );
    if (!event.target.value) {
      setErrorMessage('');
    } else {
      if (inputStatus.isValid) {
        setErrorMessage('');
        setIsValid(inputStatus.isValid);
      } else {
        setErrorMessage(inputStatus.errorMessage);
      }
    }
    props.handleChange(props.questionType, customerInput, inputStatus.isValid);
  };

  const filterNumericValue = (data: any) => data.replace(/\D/g, '');

  const handleBlur = () => {
    setIsValid(!!props.selectedValue && !!props.isValid);
  };

  const invalidMessage = props.isValid
    ? ''
    : props.errorMessage || errorMessage;
  const checkValid = () => {
    if (props.isValid) {
      return false;
    } else {
      if (errorMessage && !isValid) {
        return true;
      }
      if (isValid && props.errorMessage) {
        return true;
      }
    }
  };
  const isInputValid = checkValid();

  return (
    <>
      {!props.immutable ? (
        <>
          {props.helpText ?
            <HelpText labelText={props.labelText} message={props.helpText} helpTextClassName="enquiry-text-box-label" referenceId={props.questionType}/>
            :
            <Label htmlFor={props.questionType} className="enquiry-text-box-label">{props.labelText}</Label>
          }
          <Input
            id={props.questionType}
            name={props.name || 'input-text-box'}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={props.placeholderText || ''}
            value={props.selectedValue}
            invalid={isInputValid}
            inputMode={props.isNumeric ? 'numeric' : 'text'}
            suffix={props.postfixText}
            disabled={!!props.disabled}
            wrapperProps={{
              className: props.questionType
            }}
            {...props.ariaDescribedBy ? { 'aria-describedby': props.ariaDescribedBy } : {}}
          />
          {
            invalidMessage && !isValid &&
            <ValidationMessage
              htmlFor={props.questionType}
            ><div dangerouslySetInnerHTML={{ __html: invalidMessage }}></div></ValidationMessage>
          }
        </>
      ) : (
        <EnquiryOptionImmutable
          labelText={props.labelText}
          helpText={props.disabledHelpText}
          selectedValue={props.selectedValue}
          referenceId={props.questionType}
        />
      )}
    </>
  );
};
